// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"BillOfMaterialRowModal_modalHeader__TC2Qb","closeButton":"BillOfMaterialRowModal_closeButton__3sFlC","spinner":"BillOfMaterialRowModal_spinner__14o9c"};